import { render, staticRenderFns } from "./BrowserCompatibility.vue?vue&type=template&id=0ef29144&scoped=true&"
import script from "./BrowserCompatibility.vue?vue&type=script&lang=js&"
export * from "./BrowserCompatibility.vue?vue&type=script&lang=js&"
import style0 from "./BrowserCompatibility.vue?vue&type=style&index=0&id=0ef29144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef29144",
  null
  
)

export default component.exports